import { Card, Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import { IComment } from 'interfaces/comments';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { ShowLayout } from '../../../components/layout/layout/ShowLayout';
import { useShow } from '@refinedev/core';

const { Title, Text } = Typography;

export const CommentsShow = () => {
  const { queryResult } = useShow<IComment>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader
        title="Visualizar comentário de aula"
        icon={CommentOutlined}
      />
      <Card>
        <Title level={5}>ID</Title>
        <Text>{record?.id}</Text>

        <Title level={5}>Autor</Title>
        <Text>
          {record?.user?.full_name_or_name ?? '--'} ({record?.user?.email})
        </Text>

        <Title level={5}>Texto</Title>
        <Text>{record?.text}</Text>

        {/* TODO: Verificar o que é essa localização. Esta dando erro */}
        {/* <Title level={5}>Localização</Title>
          {record?.parent_kind !== 'comment' && (
            <Text>{record?.parent_description}</Text>
          )} */}

        {record?.parent_kind === 'comment' && (
          <Link to={`/communication/comments/show/${record?.parent_reference}`}>
            <Text style={{ color: 'blue' }}>{record?.parent_description}</Text>
          </Link>
        )}
      </Card>
    </ShowLayout>
  );
};
